import ScrollReveal from "../../../components/feature/ScrollReveal";
import { flowData } from "../../../mocks/yokohamaData";

export default function FlowSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-16">
              <p className="section-label mb-3">{flowData.label}</p>
              <h2 className="section-title">{flowData.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">{flowData.subtitle}</p>
            </div>
          </ScrollReveal>

          <div className="relative">
            <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-px bg-airdoa-gold/30" />

            <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-4">
              {flowData.steps.map((step, idx) => (
                <ScrollReveal key={step.num} direction="up" delay={idx * 120}>
                  <div className="text-center">
                    <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold mb-5 border-4 border-airdoa-cream relative z-10">
                      <span className="text-sm font-bold font-serif">{step.num}</span>
                    </div>
                    <h3 className="text-sm font-serif font-semibold text-airdoa-navy">{step.title}</h3>
                    <p className="mt-2 text-xs md:text-sm text-airdoa-gray leading-[1.9]">{step.desc}</p>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
